(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const instances = new WeakMap();
  const within = (root, selector) => [ ...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector) ];
  function initHeader(header) {
    if (instances.has(header)) return;
    const controller = new AbortController();
    const on = (node, name, handler) => node?.addEventListener(name, handler, { signal: controller.signal });
    const mobile = header.querySelector('[data-wy2-menu-toggle]');
    const nav = header.querySelector('[data-wy2-nav]');
    const toggles = [...header.querySelectorAll('[data-wy2-dropdown-toggle]')];
    const set = (toggle, open) => {
      toggle.setAttribute('aria-expanded', String(open));
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) menu.hidden = !open;
    };
    const close = () => toggles.forEach(toggle => set(toggle, false));
    const setMobile = open => { mobile?.setAttribute('aria-expanded', String(open)); nav?.classList.toggle('is-open', open); if (!open) close(); };
    on(mobile, 'click', () => setMobile(mobile.getAttribute('aria-expanded') !== 'true'));
    toggles.forEach(toggle => on(toggle, 'click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; close(); set(toggle, open); }));
    on(document, 'click', event => { if (!header.contains(event.target)) { close(); setMobile(false); } });
    on(header, 'keydown', event => {
      if (event.key === 'Escape') {
        const active = toggles.find(toggle => toggle.getAttribute('aria-expanded') === 'true');
        if (active) { close(); active.focus(); } else if (nav?.classList.contains('is-open')) { setMobile(false); mobile?.focus(); }
      }
    });
    on(header, 'focusout', event => { if (event.relatedTarget && !header.contains(event.relatedTarget)) close(); });
    on(header, 'shopify:block:select', event => {
      const item = event.target.closest('.wy2-nav-item');
      if (item) { setMobile(true); close(); const toggle = item.querySelector('[data-wy2-dropdown-toggle]'); if (toggle) set(toggle, true); }
    });
    instances.set(header, () => controller.abort());
  }
  function initHero(hero) {
    if (instances.has(hero)) return;
    const slides = [...hero.querySelectorAll('[data-wy2-slide]')];
    if (!slides.length) return;
    const controller = new AbortController();
    const on = (node, name, handler) => node?.addEventListener(name, handler, { signal: controller.signal });
    const pauseButton = hero.querySelector('[data-wy2-pause]');
    const status = hero.querySelector('[data-wy2-status-text]') || hero.querySelector('[data-wy2-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0, timer, paused = reducedMotion.matches || Boolean(window.Shopify?.designMode), hovering = false, focused = false;
    const updateButton = () => {
      if (!pauseButton) return;
      pauseButton.textContent = paused ? '▶' : 'Ⅱ';
      pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
    };
    const schedule = () => {
      clearTimeout(timer);
      if (!paused && !hovering && !focused && !document.hidden && slides.length > 1) timer = setTimeout(() => show(current + 1), Number(hero.dataset.interval) || 6000);
    };
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; slide.classList.toggle('is-active', i === current); });
      if (status) status.textContent = (hero.dataset.statusTemplate || '[current] / [total]').replace('[current]', String(current + 1)).replace('[total]', String(slides.length));
      schedule();
    };
    on(hero.querySelector('[data-wy2-prev]'), 'click', () => show(current - 1));
    on(hero.querySelector('[data-wy2-next]'), 'click', () => show(current + 1));
    on(pauseButton, 'click', () => { paused = !paused; updateButton(); schedule(); });
    on(hero, 'mouseenter', () => { hovering = true; schedule(); });
    on(hero, 'mouseleave', () => { hovering = false; schedule(); });
    on(hero, 'focusin', () => { focused = true; schedule(); });
    on(hero, 'focusout', event => { focused = hero.contains(event.relatedTarget); schedule(); });
    on(document, 'visibilitychange', schedule);
    on(reducedMotion, 'change', () => { if (reducedMotion.matches) paused = true; updateButton(); schedule(); });
    on(hero, 'shopify:block:select', event => {
      const index = slides.indexOf(event.target.closest('[data-wy2-slide]'));
      if (index >= 0) { paused = true; updateButton(); show(index); }
    });
    updateButton(); show(0);
    instances.set(hero, () => { controller.abort(); clearTimeout(timer); });
  }
  function initInquiry(root) {
    const selected = new URLSearchParams(window.location.search).get('membership_plan')?.trim().slice(0, 160);
    if (!selected) return;
    within(root, '[data-wy2-inquiry]').forEach(summary => {
      summary.querySelector('[data-wy2-selected-plan]').textContent = selected;
      summary.hidden = false;
    });
    within(root, '[data-wy2-inquiry-email]').forEach(link => {
      const destination = new URL(link.href);
      destination.searchParams.set('subject', selected);
      link.href = destination.href;
    });
  }
  const init = root => { initInquiry(root); within(root, '[data-wy2-header]').forEach(initHeader); within(root, '[data-wy2-hero]').forEach(initHero); };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => within(event.target, '[data-wy2-header], [data-wy2-hero]').forEach(element => { instances.get(element)?.(); instances.delete(element); }));
})();
